<template>
	<v-layout>
		<v-flex xs12>
			<v-container v-bind="{ [`grid-list-sm`]: true }" fluid>
				<v-layout row wrap>
					<v-flex
						v-for="item in filterProducts(group.products)"
						:key="item.id"
						xs6
						:class="{'product-crosssel-highlight-border': isCrossSellHighlightedItemFn(crossSellProductToHighlight, item.id)}"
					>
						<div v-if="isCrossSellHighlightedItemFn(crossSellProductToHighlight, item.id)" class="width-100 product-crosssel-highlight-box">
							{{ crossSellProductToHighlight.highlightProductLabel | translate(`crossSellProductToHighlight.${crossSellProductToHighlight.id}.options.highlightProductLabel`) }}
						</div>
						<div class="sub-product-wrapper">
							<div @click="changeSelection(item.id)" class="sub-product-content">
								<v-card flat tile>
									<img :src="backImg(item)[0]" width="116px" height="67px" :alt="item.displayName">
								</v-card>
								<div class="subproduct-name"> {{item.name | translate(`product.${item.id}.name`)}}</div>
								<div :class="{'checked-text' : item.id===selectedSubproducts}" data-cy="item-price">{{
									getSubproductPrice(item) }}
								</div>
							</div>
							<v-checkbox class="subproduct-checkbox"
										:key="item.id"
										:value="item.id"
										v-model="selectedSubproducts"
										hide-details
							>
							</v-checkbox>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
		</v-flex>
	</v-layout>
</template>

<script>
	import * as Utils from "../../../../../libraries/utils";
	import {formatPrice} from "../../../../../domains2/libraries/Utils";
	import appConfig, {channelEnum} from "../../../../../appconfig";
	import {canBePickedUp} from "../../../../../libraries/utils";
	import {mapGetters} from "vuex";
	import {isCrossSellHighlightedItem} from "../../../../../helper/ProductHelper";

	export default {
		name: "CheckboxGroup-gt3",
		props: ["group", "changeGroupProductSelection", "productSelection", "isSingleMenuPage", "crossSellProductToHighlight"],
		data() {
			const self = this;
			return {
				selectedSubproducts: (() => {
					const selectedProductGroup = self.productSelection.groups.find(group => group.groupId === self.group.id);
					if (selectedProductGroup) {
						if (selectedProductGroup.selectedProducts && selectedProductGroup.selectedProducts.length > 0) {
							return selectedProductGroup.selectedProducts;
						} else {
							return [];
						}
					} else {
						return [];
					}
				})()
			};
		},
		computed: {
			...mapGetters([
				"globalSelectedShop",
				"productCatalog"
			]),
			staticPath() {
				return Utils.getStaticPath();
			},
			isKioskChannel() {
				return appConfig.channelAlias() === channelEnum.kiosk;
			}
		},
		methods: {
			isCrossSellHighlightedItemFn(crossSellProductToHighlight, productId) {
				return isCrossSellHighlightedItem(crossSellProductToHighlight, productId);
			},
			filterProducts(products) {
				const filteredProducts = products.filter(product => {
					return canBePickedUp(
						product,
						this.productCatalog,
						this.$store.getters.cachedPickupRules,
						this.globalSelectedShop.id
					);
				});
				// if crossSellProductToHighlight && crossSellProductToHighlight.highlightProductId is equal to item.id
				// put that item at the 2nd position in the array
				if (this.crossSellProductToHighlight && this.crossSellProductToHighlight.highlightProductId) {
					const highlightProductId = this.crossSellProductToHighlight.highlightProductId;
					const highlightProductIndex = filteredProducts.findIndex(product => product.id === highlightProductId);
					if (highlightProductIndex !== -1) {
						const highlightProduct = filteredProducts.splice(highlightProductIndex, 1)[0];
						filteredProducts.splice(1, 0, highlightProduct);
					}
				}
				return filteredProducts;
			},
			getSubproductPrice(product) {
				const self = this;
				const price = isNaN(parseInt(product.getPriceInGroup())) ? 0 : parseInt(product.getPriceInGroup());
				const formattedPrice = formatPrice(price);
				return self.group.options.customPriceLabel ? `${formattedPrice} ${self.group.options.customPriceLabel}` : formattedPrice;
			},
			backImg(product) {
				return Utils.getBackImages(product, this.isKioskChannel);
			},
			changeSelection(productId) {
				const self = this;
				const index = self.selectedSubproducts.findIndex(val => val === productId);
				if(index !== -1) {
					self.selectedSubproducts.splice(index, 1);
				} else {
					self.selectedSubproducts.push(productId);
				}
			}
		},
		watch: {
			selectedSubproducts() {
				const self = this;
				self.changeGroupProductSelection(self.group, self.selectedSubproducts);
			}
		}
	};
</script>
